var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 72,
    viewBox: "0 0 26 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5008_42386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.44408 26.6286C5.80224 26.4305 1.55679 27.3592 0.986846 25.6576C0.31975 23.6669 2.04255 22.6732 1.99721 21.6795C1.9454 20.5104 0.128692 17.3637 0.0185885 14.756C-0.823377 -4.95578 27.227 -5.37144 25.2517 16.2466C24.9149 19.9227 22.8618 22.4621 24.0438 26.6253H15.7439L15.1125 19.8155L16.8644 19.4518L16.9324 15.3276H7.44732C7.58333 16.5161 7.19797 17.9742 7.45703 19.0881C7.57685 19.6012 8.68112 19.2602 8.67788 20.3383C8.67788 21.6438 7.79706 25.0828 7.44732 26.6253C7.86183 26.674 8.65198 26.3655 8.64227 26.9306C4.74331 35.0523 7.4376 42.4954 6.84499 50.6951C6.49201 55.576 4.72712 65.1007 3.37674 69.8386C3.09176 70.8388 3.82039 71.5013 2.11379 71.2155C2.402 64.4642 5.11573 57.3004 5.65977 50.6951C6.10342 45.3142 4.46157 39.9137 5.12543 34.7016C5.42984 32.3148 6.8709 29.155 7.44732 26.6253L7.44408 26.6286ZM12.7809 1.06819C7.12996 0.629781 2.84889 5.46193 1.52118 10.5734C3.81716 8.73207 5.34241 5.77694 7.74525 4.03633C9.46804 2.78607 11.5503 2.63994 12.7809 1.06494V1.06819Z",
    fill: "#D56B4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8612 26.6831C12.8794 26.5416 9.31753 26.8921 9.08594 26.6799L10.3059 19.6474L13.2676 19.6152C13.098 21.9948 13.5057 24.355 13.8612 26.6831C16.6599 27.085 15.3389 29.381 15.8053 31.5386C17.1753 37.8637 19.3411 46.475 21.321 52.5942C21.8658 54.2792 26.1909 63.3086 25.8028 63.7716C24.8797 64.8713 24.5144 62.942 24.3186 62.614C19.514 54.5429 15.3128 36.198 13.8612 26.6863V26.6831Z",
    fill: "#D56B4E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5008_42386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLed);
export default __webpack_public_path__ + "static/media/led.b8cc68f64f2c870364bff956f5fc7b1a.svg";
export { ForwardRef as ReactComponent };